import PropTypes from 'prop-types'

import ArrowRight from 'src/assets/img/shop/dark_pink_arrow.png'

const ConfirmModal = ({ item, currentPoint, pointSpend }) => {
  return (
    <div className="bg-white tracking-wide font-semibold font-ShinMaruGo w-full py-6 text-candy-pink text-center">
      <p>
        交換ポイントを消費して
        <br />
        {item.item_name}を1枚
        <br />
        獲得しますか？
      </p>
      <div className="flex my-6 items-center gap-4 justify-center">
        <p className="text-silver">{currentPoint} pt</p>
        <img className="w-3 h-3 mx-1.5" src={ArrowRight} alt="arrow" />
        <p className="text-[#FF4747]">{currentPoint - pointSpend} pt</p>
      </div>
      <div className="text-lg">
        <p>
          選択した素材アイテムも
          <br />
          消費されます。
        </p>
        <p>
          消費後の素材アイテムの返却は
          <br />
          行えません。ご注意くさい。
        </p>
      </div>
    </div>
  )
}

ConfirmModal.propTypes = {
  item: PropTypes.object,
  currentPoint: PropTypes.number.isRequired,
  pointSpend: PropTypes.number.isRequired
}

export default ConfirmModal
